/**
 * PPT: "Women's 4.5 Singles" (Singles after rating), not "Singles Women's 4.5".
 */
export function formatSeasonDisplayName(name) {
  if (name == null || name === "") return name;

  const raw = String(name)
    .replace(/[\u2018\u2019\u201B\u02BC]/g, "'")
    .replace(/\s+/g, " ")
    .trim();

  const prefRe = "(Singles|Single|Doubles|Mixed Doubles)";
  const genderRe = "(Men's|Women's|Mens|Womens)";
  const levelRe = "(\\d+(?:\\.\\d+)?)";

  const normalize = (title, gender, level, pref) => {
    let g = gender;
    if (/^mens$/i.test(g)) g = "Men's";
    if (/^womens$/i.test(g)) g = "Women's";
    if (/^men's$/i.test(g)) g = "Men's";
    if (/^women's$/i.test(g)) g = "Women's";

    let p = pref;
    if (/^single$/i.test(p)) p = "Singles";
    if (/^singles$/i.test(p)) p = "Singles";
    if (/^doubles$/i.test(p) && !/mixed/i.test(p)) p = "Doubles";
    if (/mixed/i.test(p)) p = "Mixed Doubles";

    const head = String(title || "").trim();
    return `${head} ${g} ${level} ${p}`.replace(/\s+/g, " ").trim();
  };

  // Already correct: Title Women's 4.5 Singles
  let m = raw.match(
    new RegExp(`^(.*?)\\s+${genderRe}\\s+${levelRe}\\s+${prefRe}\\s*$`, "i")
  );
  if (m) return normalize(m[1], m[2], m[3], m[4]);

  // Wrong PPT order: Title Singles Women's 4.5
  m = raw.match(
    new RegExp(`^(.*?)\\s+${prefRe}\\s+${genderRe}\\s+${levelRe}\\s*$`, "i")
  );
  if (m) return normalize(m[1], m[3], m[4], m[2]);

  // Title Women's Singles 4.5
  m = raw.match(
    new RegExp(`^(.*?)\\s+${genderRe}\\s+${prefRe}\\s+${levelRe}\\s*$`, "i")
  );
  if (m) return normalize(m[1], m[2], m[4], m[3]);

  return raw;
}
